import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

// Also used everywhere else!!
export const ActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${token('color.background.accent.gray.subtlest', '#f4f5f7')};
  padding: 6px;
  margin-top: 3px;
  margin-bottom: 15px;
`;

// Also used everywhere else!!
export const ActionWrapperOuter = styled.div`
  width: 100%;
`;
export const ActionWrapperInnerLeft = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
`;
export const ActionWrapperInnerRight = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
